<template>
  <div id="app-content">
    <div v-if="!confirm" id="form-step01">

      <section id="step01" class="step">
        <div class="container">
          <header class="step__header">
            <h2 class="step__title">
              <span class="step__title--label">STEP</span><span class="step__title--number">01</span>
            </h2>
            <h3 class="step__subtitle">来店日時予約</h3>
            <p class="step__lead">
              代官山店・福岡店・梅田店からご都合の良い日時を<br />最大3つまで選択してください。<br class="hidden-lg" />（所要時間：1時間〜1時間半）
              
              <!-- <br /><small>※ご好評につき代官山店は受付終了となりました。</small> -->
            </p>
          </header>
          <div class="calendar">
            <v-select
              class="store-selector"
              name="currentShop"
              :options="options"
              v-model="shop"
              :searchable=false
              :clearable=false
              :autoscroll=false
              :taggable=false
            >

              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"><svg 
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 36 36">
                <path fill-rule="evenodd"  fill="rgb(0, 0, 0)"
                d="M36.0,18.0 C36.0,27.941 27.941,36.0 18.0,36.0 C8.58,36.0 0.0,27.941 0.0,18.0 C0.0,8.58 8.58,0.0 18.0,0.0 C27.941,0.0 36.0,8.58 36.0,18.0 Z"/>
                <path fill-rule="evenodd"  fill="rgb(255, 255, 255)"
                d="M11.28,16.117 C11.28,16.368 11.125,16.619 11.319,16.811 L17.282,22.696 C17.671,23.79 18.300,23.79 18.688,22.696 L24.651,16.811 C25.40,16.427 25.40,15.807 24.651,15.424 C24.263,15.41 23.634,15.41 23.246,15.424 L17.985,20.615 L12.724,15.424 C12.336,15.41 11.707,15.41 11.319,15.424 C11.125,15.615 11.28,15.866 11.28,16.117 Z"/>
                </svg></span>
              </template>
            </v-select>

            <div class="timetable" v-if="userData.timetable" ref="ref_tt">
              <div class="swiper-wrapper">
                <div
                  class="timetable__item swiper-slide"
                  v-for="(cal, index) in userData.timetable[shop.code]"
                  :key="cal.date"
                >
                  <h3 class="timetable__date">
                    <time class="timetable__date--year">{{ cal.date.split('/')[0] }}</time>
                    <time class="timetable__date--day">{{ parseInt(cal.date.split('/')[1]) }}/{{ parseInt(cal.date.split('/')[2]) }}</time>
                    <time class="timetable__date--week">{{ cal.date | week }}</time>
                  </h3>
                  <ul class="timetable__list">
                    <li v-for="(state, hour) in cal.hours" :key="hour">
                      <label>
                        <input
                          type="checkbox"
                          :class="{'disabled': state === 'disabled'}"
                          :disabled="state === 'disabled' || (selectedDate.length >= 3 && !userData.timetable[shop.code][index].hours[hour])"
                          :value="cal.date + ' ' + hour"
                          v-model="userData.timetable[shop.code][index].hours[hour]"
                        />
                        <span>{{ hour.replace(':', ' : ') }}</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="timetable__arrow timetable__arrow--next"></div>
              <div class="timetable__arrow timetable__arrow--prev"></div>
            </div>
          </div>
        </div>
      </section>

      <section id="step02" class="step">
        <div class="container">
          <header class="step__header">
            <h2 class="step__title">
              <span class="step__title--label">STEP</span><span class="step__title--number">02</span>
            </h2>
            <h3 class="step__subtitle">お客様情報入力</h3>
            <p class="step__lead"><em>＊</em>は必須項目です</p>
          </header>
          <div class="form">
            <div class="form__row form__group">
              <div class="form__column">
                <label>
                  <dl>
                    <dt class="required">お名前</dt>
                    <dd>
                      <input
                        type="text"
                        name="name"
                        value=""
                        placeholder="入力してください"
                        v-model="userData.name"
                        required
                      />
                    </dd>
                  </dl>
                </label>
              </div>
              <div class="form__column">
                <label>
                  <dl>
                    <dt class="required">ふりがな</dt>
                    <dd>
                      <input
                        type="text"
                        name="kana"
                        value=""
                        placeholder="入力してください"
                        v-model="userData.kana"
                        required
                      />
                    </dd>
                  </dl>
                </label>
              </div>
            </div>
            <div class="form__group">
              <label>
                <dl>
                  <dt class="required">ご住所</dt>
                  <dd>
                    <input
                      type="text"
                      name="address"
                      value=""
                      placeholder="入力してください"
                      v-model="userData.address"
                      required
                    />
                  </dd>
                </dl>
              </label>
            </div>
            <div class="form__group">
              <label>
                <dl>
                  <dt class="required">お電話番号</dt>
                  <dd>
                    <input
                      type="text"
                      name="tel"
                      value=""
                      placeholder="入力してください"
                      v-model="userData.tel"
                      required
                    />
                  </dd>
                </dl>
              </label>
            </div>
            <div class="form__group">
              <label>
                <dl>
                  <dt class="required">メールアドレス</dt>
                  <dd>
                    <input
                      type="email"
                      name="email"
                      value=""
                      placeholder="入力してください"
                      v-model="userData.email"
                      required
                    />
                  </dd>
                </dl>
              </label>
            </div>
            <div class="form__group form__row">
              <div class="form__column">
                <label>
                  <dl>
                    <dt class="required">
                      身長
                    </dt>
                    <dd>
                      <input type="text" v-model="userData.height" placeholder="入力してください" required />
                    </dd>
                  </dl>
                </label>
              </div>
              <div class="form__column">
                <label>
                  <dl>
                    <dt class="required">体重</dt>
                    <dd>
                      <input type="text" v-model="userData.weight" placeholder="入力してください" required />
                    </dd>
                  </dl>
                </label>
              </div>
            </div>
            <div class="form__group">
              <label>
                <dl>
                  <dt>その他ご要望</dt>
                  <dd>
                    <textarea
                      type="email"
                      name="other"
                      value=""
                      placeholder="入力してください"
                      v-model="userData.other"
                    />
                  </dd>
                </dl>
              </label>
            </div>
            <div class="form__group">
              <ul class="form__notice">
                <li>ご注文後の商品のキャンセルは一切致しかねます。また、商品お渡し後の返品交換も不可となります。あらかじめご了承ください。</li>
                <li>カラーやデザインはカウンセリング当日に決めていただけます。</li>
                <li>オーダーの混雑状況などにより、納品がやむを得ず遅延する場合がございます。</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="agreement" class="step agreement">
        <div class="container">
          <div class="agreement__text">
            <p>
              弊社は、本キャンペーンにおいてご提供いただいたお客様の個人情報を、<br class="hidden-sp" />「<a
                href="https://www.descente.co.jp/jp/privacy/"
                target="_blank"
                >個人情報保護方針</a
              >」の定め（個人情報の利用目的を含みます）に従って取り扱うとともに、その他以下に記載する利用目的に利用いたします。
            </p>
            <p>（１）本キャンペーンの運営・実施・管理<br />（２）商品発送のほか、本キャンペーンに関するお客様対応</p>
          </div>

          <div class="agreement__button">
            <label>
              <input type="checkbox" name="agree" v-model="agree" />
              <span
                >「<a href="https://www.descente.co.jp/jp/privacy/" target="_blank">個人情報保護方針</a
                >」の内容を確認し、<br class="hidden-pc" />同意しました。</span
              >
            </label>
          </div>
        </div>
      </section>

      <section id="submit">
        <div v-if="errors.length" class="submit__erros">
          <span v-for="err in errors" :key="err">{{ err }}</span>
        </div>
        <a href="../" class="submit__back">BACK</a>
        <button type="button" name="next" class="submit__next" @click="submit" :disabled="!this.filled">NEXT</button>
      </section>
    </div>

    <div v-else id="confirm">
      <form method="post" @submit="send">
        <h2 class="confirm__title">入力内容確認</h2>

        <div class="confirm__block confirm__block--date">
          <div class="container">
            <h3 class="confirm__subtitle">来店希望日時</h3>
            <div class="confirm__block--date__label">
              {{ shop.label }}
            </div>
            <div class="confirm__block--date__list">
              <dl v-for="date in selectedDate" :key="date">
                <dt>{{ shop.label }}</dt>
                <dd>{{ date | shorten_date}}</dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="confirm__block confirm__block--information">
          <div class="container">
            <h3 class="confirm__subtitle">お客様情報</h3>

            <div class="confirm__row">
              <dl class="confirm__col">
                <dt>氏名</dt>
                <dd>{{ userData.name }}</dd>
              </dl>

              <dl class="confirm__col">
                <dt>ふりがな</dt>
                <dd>
                  {{ userData.kana }}
                </dd>
              </dl>
            </div>

            <dl>
              <dt>住所</dt>
              <dd>{{ userData.address }}</dd>
            </dl>

            <dl>
              <dt>電話番号</dt>
              <dd>{{ userData.tel }}</dd>
            </dl>

            <dl>
              <dt>メールアドレス</dt>
              <dd>{{ userData.email }}</dd>
            </dl>

            <div class="confirm__row">
              <dl class="confirm__col">
                <dt>身長</dt>
                <dd>{{ userData.height }}</dd>
              </dl>

              <dl class="confirm__col">
                <dt>体重</dt>
                <dd>{{ userData.weight }}</dd>
              </dl>
            </div>

            <dl class="other">
              <dt>その他ご要望</dt>
              <dd>{{ userData.other }}</dd>
            </dl>
          </div>
        </div>

        <div class="confirm__block confirm__block--message">
          <div class="container">
            <em>こちらを送信しただけでは予約完了にはなりません。</em><br />
            後ほど予約確定のメールをお送りいたします。<br />
            選択いただいた来店希望日時がご希望に添えない場合は、お電話にてご連絡させていただきます。
          </div>
        </div>

        <section id="submit">
          <button type="button" class="submit__back" :disabled="this.sent" @click="back">BACK</button>
          <button type="subtmi" class="submit__next" :disabled="this.sent">SEND</button>
          <div v-if="this.errors.length" class="submit__error">
            {{ errors.join('/') }}
          </div>
          <div v-if="sent" class="submit__sent">
            <p>ご記入いただいた情報は無事に送信されました。<br>後ほど、DESCENTEスタッフよりメールにてご連絡いたします。</p>
            <p>
              当社からのメールが2営業日内に届かない場合は、予約希望店舗までお電話をお願いいたします。<br>
              DESCENTE BLANC 代官山 : 03-6416-5989 (11:00〜20:00)<br>
              DESCENTE BLANC 福岡 : 092-753-6262 (12:00〜20:00)<br>
              DESCENTE BLANC 梅田 : 
            </p>
          </div>
        </section>
      </form>
    </div>
  </div>
</template>


<script type="text/javascript">
import Vue from 'vue'
import axios from 'axios'
import Swiper from 'swiper/bundle'
// import 'swiper/swiper-bundle.css'
import colorJson from '../color.json'

const JSON_URL = '../calendar.json?' + Math.random()
// const API_BASE_URL = 'http://localhost:8080'
// const API_BASE_URL = 'https://fw7cyr5awd.execute-api.ap-northeast-1.amazonaws.com/test'
const API_BASE_URL = 'https://fw7cyr5awd.execute-api.ap-northeast-1.amazonaws.com/prod'

const FIELD_REQUIRED = ['name', 'kana', 'address', 'tel', 'email', 'height', 'weight']
const FIELD_LABELS = {
  name: 'お名前',
  kana: 'ふりがな',
  address: 'ご住所',
  tel: 'お電話番号',
  email: 'メールアドレス',
  height: '身長',
  weight: '体重',
  other: 'その他ご要望',
}
let swiper

export default {
  data() {
    return {
      confirm: false,

      options: [
        {label: '代官山店', code: 'DAIKANYAMA'},
        {label: '福岡店', code: 'FUKUOKA'},
        {label: '梅田店', code: 'UMEDA'},
      ],
      
      errors: [],
      confirm: false,
      sent: false,

      colors: null,
      calendar: null,
      agree: false,


      // form data
      // shop: 'DAIKANYAMA',
      shop: {label: '代官山店', code: 'DAIKANYAMA'},
      userData: {
        
        // timetable: null,
        name: null,
        kana: null,
        address: null,
        tel: null,
        email: null,
        height: null,
        weight: null,
        other: null,

        // dummydata
        // name: '名前',
        // kana: 'なまえ',
        // address: '横浜市',
        // tel: '909000090',
        // email: 'test@example.com',
        // height: '190cm',
        // weight: '40kg',
        // other: 'tur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      },
    }
  },
  computed: {
    filled: function() {
      return true
      console.log(this.userData)

      const filled = !FIELD_REQUIRED.find(key => {
        return !this.userData[key]
      })
      const vailed_email = this.userData['email'] && this.userData['email'].match(/.+@.+\..+/) !== null

      return (
        this.agree &&
        filled &&
        vailed_email &&
        this.selectedDate &&
        this.selectedDate.length &&
        this.selectedDate.length <= 3
      )
    },
    selectedDate: function() {
      if (!this.userData.timetable) return null
      const shopData = this.userData.timetable[this.shop.code]
      let result = []
      shopData.forEach(d => {
        const hours = Object.keys(d.hours)
        hours.forEach((h, state) => {
          if (d.hours[h] === true) {
            result.push(d.date + ' ' + h)
          }
        })
      })
      return result.sort()
    },
  },
  watch: {
    $route: function(to, from) {
      switch (to.path) {
        case '/':
          this.confirm = false
          document.title = '予約フォーム｜DESCENTE PAUSEパターンオーダー MADE TO MEASURE'
          break
        case '/confirm':
          this.confirm = true
          document.title = '入力内容確認｜DESCENTE PAUSEパターンオーダー MADE TO MEASURE'
          break
        default:
      }
    },
  },
  created() {
    // if(this.$route.path )
    if (this.$route.path !== '/') {
      this.$router.push('/')
    }

    axios
      .get(JSON_URL, { sending: false })
      .then(response => {
        this.$emit('data_fetched')
        this.calendar = response.data
        this.createTimetable()

        return this
      })
  },
  methods: {
    createTimetable() {
      const tt_object = JSON.parse(JSON.stringify(this.calendar))
      const shoplist = Object.keys(tt_object)
      shoplist.forEach(shop => {
        tt_object[shop].forEach(day => {
          // console.log(day.hours)
          const hours = Object.keys(day.hours)

          hours.forEach(hour => {
            if (!day.hours[hour]) {
              day.hours[hour] = 'disabled'
            } else {
              day.hours[hour] = false
            }
          })
        })
      })
      this.$set(this.userData, 'timetable', tt_object)
    },
    submit: function(e) {
      this.errors = []
      let filled = true
      FIELD_REQUIRED.forEach(key => {
        if (!this.userData[key]) {
          // this.errors.push(FIELD_LABELS[key] + 'が入力されていません');
          filled = false
        }
      })
      if (!filled) {
        this.errors.push('必須項目が入力されていません')
      }

      const vailed_email = this.userData['email'] && this.userData['email'].match(/.+@.+\..+/) !== null
      if (!vailed_email) {
        this.errors.push('メールアドレスが正しくありません')
      }
      // const vailed_kana = this.userData['kana'] && this.userData['kana'].match(/^[ぁ-んーァ-ヶｦ-ﾟ　 ]*$/) !== null
      // if (this.userData['kana'] && !vailed_kana) {
      //   this.errors.push('ふりがなを正しく入力してください')
      // }

      if (!this.agree) {
        this.errors.push('個人情報保護方針に同意する必要があります')
      }

      if (!(this.selectedDate && this.selectedDate.length)) {
        this.errors.push('ご都合の良い日時を選択してください')
      }
      if (!(this.selectedDate && this.selectedDate.length <= 3)) {
        this.errors.push('希望の来店日時指定は3つまでになります')
      }

      if (this.errors.length) {
        e.preventDefault()
        return false
      } else {
        this.confirm = true
        this.$router.push('/confirm')
        window.scrollTo(0, 0)
      }
    },
    back: function() {
      this.confirm = false
      this.$router.push('/')
      window.scrollTo(0, 0)
    },
    clickHour: function(cal, hour) {
      const fullDate = cal.date + ' ' + hour
      const isset = this.userData.hours && this.userData.hours[fullDate] ? true : false
      // console.log(isset)
      if (isset) {
        this.$delete(this.userData.hours, fullDate)
      } else {
        this.$set(this.userData.hours, fullDate, !isset)
      }
    },
    send: function(e) {
      this.errors = []
      const request = {
        shop: this.shop.label,
        bookingDateTime: this.selectedDate,
        name: this.userData.name,
        kana: this.userData.kana,
        address: this.userData.address,
        tel: this.userData.tel,
        email: this.userData.email,
        height: this.userData.height,
        weight: this.userData.weight,
        other: this.userData.other,
      }

      axios.defaults.baseURL = API_BASE_URL
      axios
        .post('/', request)
        .then(response => {
          if (response.status === 200) {
            this.sent = true
            this.errors = []
          }
        })
        .catch(error => {
          this.errors.push('送信できませんでした ' + error)
        })

      if (e) {
        e.preventDefault()
        return false
      } else {
        return request
      }
    },
    __testTT: function() {
      setTimeout(() => {
        const ttinput = this.$refs.ref_tt.querySelectorAll('input')
        let i = 0
        setInterval(() => {
          const d = ttinput[i]
          if (d && !d.disabled) {
            var event = document.createEvent('MouseEvents')
            event.initEvent('click', false, false)
            d.dispatchEvent(event)

            setTimeout(() => {
              const response = this.send()
              var event = document.createEvent('MouseEvents')
              event.initEvent('click', false, false)
              console.log(d.value === response.bookingDateTime[0])
              d.dispatchEvent(event)
            }, 100)
          }

          i += 1
        }, 200)
      }, 1000)
    },
  },

  mounted() {
    this.colors = colorJson.colors
    // this.__testTT()
  },
  updated() {
    if (!this.swiper && this.userData.timetable) {
      this.swiper = new Swiper('.timetable', {
        slidesPerView: 'auto',
        spaceBetween: 2,
        navigation: {
          nextEl: '.timetable__arrow--next',
          prevEl: '.timetable__arrow--prev',
        },
        threshold: 10,
      })
    }
    if (this.swiper) {
      this.swiper.update()
    }
  },
  components: {},
}
</script>
